/**
 * @email       : kpozos@ibl.mx
 * @author      : Karen Yunuen Pozos Arias
 * @title       : Full Stack Developer
 */

import {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import {useLocation, useNavigate, useOutletContext} from "react-router-dom";
import HandleChange from "../../../../Helpers/HandleChange";
import { getAllMealtimes } from "../../../../reduxToolkit/FoodieOrders/FoodieOrdersApi";
import routes from "../../../../Routes/routes";

const SelectionMealsMainApp = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    let { state } = location; // Get state from location
    const servingDate = state?.servingDate; // Get state from location
    const mealTimeId = state?.mealTimeId; // Get state from location
    // Context hook to access meal and its updater from parent route
    const { meal, setMeal } = useOutletContext();
    const { handleChange: handleChangeModel } = HandleChange({ model: meal, setModel: setMeal })

    // Redux selectors to get global state
    const { mealtimes } = useSelector((state) => state.FoodieOrdersSlice);
    const { getFirstFoodieSetting: foodieSetting } = useSelector((state) => state.employeeFoodieSlice);
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');

    const handleChange = (e) => {
        const aux = meal.clearMenuMealsTimes();
        setMeal({ ...aux});
        handleChangeModel(e);
    }

    useEffect(() => {
        if(servingDate) setMeal(prev => ({...prev, date: servingDate }));
    }, [servingDate]);

    useEffect(() => {
        if(mealTimeId) setMeal(prev => ({...prev, mealTime: mealTimeId }));
    }, [mealTimeId]);

    useEffect(() => {
        dispatch(getAllMealtimes());
    }, [dispatch]);

    const handleClearBasket = () => {
        const aux = meal.clearMenuMealsTimes();
        setMeal({ ...aux});
    };

    const goToBasket = () => {
        let path = routes.foodieOrders.basket;

        if (contractorId) {
            path = routes.contractor.basket;
        } else if (supplierId) {
            path = routes.suppliers.basket;
        }

        navigate(path, {
            state: state,
        });
    };

    /**
     * Handles navigation to the previous page or a default route.
     */
    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl.pathname, {
                state: {...state.backUrl.state}
            });
        } else {
            navigate(contractorId
                ? routes.contractor.foodie
                : supplierId
                    ? routes.suppliers.foodie
                    : routes.foodieOrders.main)
        }
    }

    return {
        meal,
        foodieSetting,
        mealtimes,
        handleChange,
        contractorId,
        supplierId,
        servingDate,
        mealTimeId,
        handleClearBasket,
        goToBasket,
        goBack
    };
};

export default SelectionMealsMainApp;
